import React from 'react'
import { shallow } from 'enzyme'
import { DemographicsQuestions } from '../../components/DemographicsQuestions'

describe('DemographicsQuestions', () => { 
  let wrapper, props, instance

  beforeAll(() => {
    props = {
      getQuestions: () => ({
        questions_demographics: [1]
      }),
      data: {
        loading: false,
        error: false,
        guarantor: {
          rid: 2
        }
      },
    }
    wrapper = shallow(<DemographicsQuestions {...props} />)
    instance = wrapper.instance()
  })

  describe("#render", () => {
    it("renders", () => {
      expect(wrapper).toBeTruthy()
    })
  })

  describe("#getQuestionsByCategory", () => {
    it("returns array", () => {
      const arr = instance.getQuestionsByCategory('questions_demographics')

      expect(arr.length).toBe(1)
    })
  })
})
